import React from 'react';
import UserMenu from './UserMenu';
// Removed framer-motion imports

const Header: React.FC<{ onSidebarToggle?: () => void }> = ({
  onSidebarToggle
}) => {
  return (
    <header className='bg-white shadow-elegant border-b border-slate-200/60 shrink-0'>
      <div className='flex items-center space-x-4 justify-end px-8 py-4 relative md:hidden'>
        {/* Hamburger menu for mobile */}
        <button
          type='button'
          className='md:hidden absolute left-0 top-1/2 -translate-y-1/2 p-2 rounded-full hover:bg-slate-100 focus:outline-none'
          aria-label='Open sidebar'
          onClick={onSidebarToggle}
        >
          <svg
            className='h-7 w-7 text-slate-700'
            fill='none'
            viewBox='0 0 24 24'
            stroke='currentColor'
          >
            <path
              strokeLinecap='round'
              strokeWidth='2'
              d='M4 6h16M4 12h16M4 18h16'
            />
          </svg>
        </button>
        <UserMenu />
      </div>
    </header>
  );
};

export default Header;
